import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, roles }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen bg-slate-950 text-neutral-200 flex items-center justify-center">
        <div className="flex items-center space-x-3">
          <div className="w-6 h-6 border-2 border-sky-400 border-t-transparent rounded-full animate-spin" />
          <span className="text-sm">Restoring your session…</span>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (roles && !roles.includes(user.role)) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-950 text-neutral-100 p-6">
        <div className="max-w-md text-center bg-slate-900 border border-red-500/40 p-8 rounded-2xl">
          <h2 className="text-xl font-bold text-red-400">Access denied</h2>
          <p className="text-sm text-neutral-400 mt-2">You don't have permission to view this page.</p>
        </div>
      </div>
    );
  }

  return children;
}
